// extracted by mini-css-extract-plugin
export default {"products-items-style":"AssignSubProductCategoryStyles_products-items-style__DURUg","selected":"AssignSubProductCategoryStyles_selected__b9Rxu"};